import { getBackgroundImage } from '../../../utils/pageUtils';

const Image = ({ pageData, imageData, isSingleImage }) => {
    if (!imageData || typeof imageData !== 'object') {
        return null;
    }

    const { media, is_full_width, has_page_title } = imageData || {};
    const mobileImageSrc = getBackgroundImage(media, is_full_width);
    const fullWidthImageSrc = getBackgroundImage(media, is_full_width);

    return (
        <div className={is_full_width ? 'col-sm-12' : 'col-sm-6'}>
            <div className="img-wrapper">
                <div className="mobile-image-container">
                    <img className="mobile-image" src={mobileImageSrc} alt={media?.alternativeText || ''} />
                    {has_page_title && <h1 className="title">{pageData.name}</h1>}
                </div>
                {is_full_width ? (
                    <>
                        <section className="cover fullscreen-block">
                            <img src={fullWidthImageSrc} alt={media?.alternativeText || ''} />
                            {has_page_title && <h1 className="title">{pageData.name}</h1>}
                        </section>
                    </>
                ) : (
                    isSingleImage ? (
                        <div className="cover single-image img-container ratio-3x2">
                            <img src={fullWidthImageSrc} alt={media?.alternativeText || ''} className="img-responsive" />
                            {has_page_title && <h1 className="title">{pageData.name}</h1>}
                        </div>
                    ) : (
                        <div className="cover img-container ratio-3x2">
                            <img src={fullWidthImageSrc} className="img-responsive" alt={media?.alternativeText || ''} />
                            {has_page_title && <h1 className="title">{pageData.name}</h1>}
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default Image
